import React, { useEffect, useState } from "react";

import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import { useDispatch } from "react-redux";
import { Checkbox } from "@atlaskit/checkbox";
const ScriptVariableOptions = ({ scriptedVariable }) => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(scriptedVariable?.isGlobal);

  useEffect(() => {
    setIsChecked(scriptedVariable?.isGlobal);
  }, [scriptedVariable]);

  const onChange = (current) => {
    setIsChecked((current) => !current);
    scriptedVariable.isGlobal = current.target.checked;
    dispatch(setEditorSaved(false));
  };

  return <Checkbox label="Global" isChecked={isChecked} onChange={onChange} />;
};

export default ScriptVariableOptions;
